import { FC } from 'react';
import { PreloadedQuery, usePreloadedQuery } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import Page from 'components/Page';
import Pagination from 'components/Pagination';
import Search from 'components/Search';

import MenuList from 'components/MenuList';

import { withData } from 'lib';
import { ContentMenuPageQuery } from '__generated__/ContentMenuPageQuery.graphql';

const query = graphql`
  query ContentMenuPageQuery($first: Int!) {
    ...MenuList_data @arguments(first: $first)
  }
`;

type Props = {
  preloadedQuery: PreloadedQuery<ContentMenuPageQuery>;
};

const ContentMenuPage: FC<Props> = ({ preloadedQuery }) => {
  const data = usePreloadedQuery<ContentMenuPageQuery>(query, preloadedQuery);

  return (
    <Page
      breadcrumbs={[{ link: '/content', name: 'Turinys' }, { name: 'Meniu' }]}>
      <Pagination>
        <Search>
          <MenuList data={data} />
        </Search>
      </Pagination>
    </Page>
  );
};

export default withData<ContentMenuPageQuery>({
  query,
  reloadOnRender: false,
})(ContentMenuPage);
